import { createContext, useContext, useState, useEffect } from 'react';
import { tenantPortalAPI } from '../lib/api';

const TenantAuthContext = createContext(null);

export function TenantAuthProvider({ children }) {
  const [tenantUser, setTenantUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tenant_token');
    const saved = localStorage.getItem('tenant_user');

    if (token && saved) {
      setTenantUser(JSON.parse(saved));
      tenantPortalAPI.getMe()
        .then((response) => {
          const tu = response.data.tenant_user;
          setTenantUser(tu);
          localStorage.setItem('tenant_user', JSON.stringify(tu));
        })
        .catch(() => {
          localStorage.removeItem('tenant_token');
          localStorage.removeItem('tenant_user');
          setTenantUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await tenantPortalAPI.login({ email, password });
    const { access_token, tenant_user } = response.data;

    localStorage.setItem('tenant_token', access_token);
    localStorage.setItem('tenant_user', JSON.stringify(tenant_user));
    setTenantUser(tenant_user);
    return tenant_user;
  };

  const logout = () => {
    localStorage.removeItem('tenant_token');
    localStorage.removeItem('tenant_user');
    setTenantUser(null);
  };

  return (
    <TenantAuthContext.Provider value={{ tenantUser, loading, login, logout }}>
      {children}
    </TenantAuthContext.Provider>
  );
}

export function useTenantAuth() {
  const ctx = useContext(TenantAuthContext);
  if (!ctx) {
    throw new Error('useTenantAuth must be used within a TenantAuthProvider');
  }
  return ctx;
}
